module.exports = __webpack_public_path__ + "static/media/target3_0.33794814.png";